module.exports = __webpack_public_path__ + "media/images/products/products/h4-ac996bdb16245d98ea70f36cdfc19f8a.jpg";